import Autocomplete, { AutocompleteProps } from "./AutoComplete";

import { withLabel } from "composants/withLabel";

export default withLabel<AutocompleteProps>()(Autocomplete);
